import React from 'react';
import { Skeleton } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetManyOrders } from 'api/orders/use-get-many-orders.ts';
import { usePageReset } from 'shared/hooks/use-page-reset';
import { usePaginationParams } from 'shared/hooks/use-pagination-params.ts';
import { useOrderFiltersStore } from 'shared/stores';
import { OrderCreate } from 'components/orders/order-create';
import { OrdersFilter } from 'components/orders/orders-filter';
import { OrdersList } from 'components/orders/orders-list';
import { OrdersSummary } from 'components/orders/orders-summary';
import { Pagination } from 'components/pagination';

export const OrdersListPage: React.FC = () => {
  const { page, limit, handlePageChange } = usePaginationParams();
  const { search, filters } = useOrderFiltersStore();
  const { data: orders, isLoading, isPreviousData } = useGetManyOrders({ page, limit, search, filters });

  const header = <PageHeader title={<OrdersFilter />} extra={[<OrderCreate />]} />;

  usePageReset([search, filters]);

  return (
    <DefaultPageLayout header={header}>
      <Skeleton loading={isLoading}>
        <OrdersSummary />
        <OrdersList orders={orders?.data || []} isLoading={isPreviousData} />
        <Pagination
          total={orders?.pagination?.total}
          page={orders?.pagination?.currentPage}
          limit={orders?.pagination?.limit}
          onChange={handlePageChange}
        />
      </Skeleton>
    </DefaultPageLayout>
  );
};
